// Height of a ActionPlanTitleBar + ActionPlanTopBar + Navigation in the ActionPlanStep component
export const headerHeight = 129;
